var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-header--details"},[_c('h2',[_vm._v("Filtry ip:")]),_c('ul',{staticClass:"list-unstyled"},[_vm._l((_vm.formattedIps),function(ip,ipIndex){return [_c('li',{key:`ipString-${ipIndex}`},[_vm._v(" "+_vm._s(ip)+" ")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }